// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"270a773b","728":"5f6b1b52","739":"4208b6bc"}[chunkId] + ".chunk.js";
};